const maxHeapify = (arr, n, animations) => {
    for (let i = 1; i < n; i++) {
        //If child is greater than parent
        animations.push([i, parseInt((i - 1) / 2), true]);
        animations.push([i, parseInt((i - 1) / 2), false]);
        if (arr[i] > arr[parseInt((i - 1) / 2)]) {
            let j = i;
            animations.push([i, parseInt((i - 1) / 2), true]);
            animations.push([i, parseInt((i - 1) / 2), false]);
            // swap child and parent until 
            // parent is smaller
            while (arr[j] > arr[parseInt((j - 1) / 2)]) {
                animations.push([j, parseInt((j - 1) / 2), true]);
                animations.push([j, parseInt((j - 1) / 2), false]);
                //Get the indexes of both the child
                const l = j;
                const r = parseInt((j - 1) / 2);

                //Swap

                animations.push([[l, arr[r]], [r, arr[l]]]);
                [arr[l], arr[r]] = [arr[r], arr[l]];

                //reduce
                j = parseInt((j - 1) / 2);
            }
        }
    }
}

export const getHeapSort = (arr, animations, n = arr.length) => {
    maxHeapify(arr, n, animations);

    for (let i = n - 1; i > 0; i--) {
        // swap value of first indexed 
        // with last indexed 
        animations.push([[0, arr[i]], [i, arr[0]]]);
        [arr[0], arr[i]] = [arr[i], arr[0]];

        // maintaining heap property 
        // after each swapping 
        let j = 0, index;

        do {
            index = (2 * j + 1);

            // if left child is smaller than 
            // right child point index variable 
            // to right child 
            if (index < (i - 1) && arr[index] < arr[index + 1]) {
                animations.push([index, (i - 1), true]);
                animations.push([index, (i - 1), false]);
                animations.push([index, index+1, true]);
                animations.push([index, index+1, false]);
                index++;
            }

            // if parent is smaller than child 
            // then swapping parent with child 
            // having higher value 

            if (index < i && arr[j] < arr[index]) {
                animations.push([index, i, true]);
                animations.push([index, i, false]);
                animations.push([j, index, true]);
                animations.push([j, index, false]);
                animations.push([[j, arr[index]], [index, arr[j]]]);
                [arr[j], arr[index]] = [arr[index], arr[j]];
            }

            j = index;
        } while (index < i);
    }
}